<template>
  <div>
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">关于我们</div>
      <div class="t-t2box">
        <div class="t-t2">为理想而诞生</div>
      </div>
    </div>

    <div class="row1">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">谛听管理咨询（太原）有限公司</div>
        <br />
        <div class="line"></div>
        <br />
        <div class="t2">
          谛天下之物，听用户心声；<br />
          护公民权益，树诚信社会；
        </div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item2">
          <div class="b2">
            <img src="@/image/more/tu1@2x.png" alt="" />
          </div>

          <div class="b1">
            <div class="t1">公司简介</div>

            <div class="t2">谛听管理咨询（太原）有限公司是新一代企业管理咨询公司的卓越代表。 公司由曾任职于国内一流管理咨询公司、 拥有十年以上丰富企业管理咨询经验的核心团队创立。</div>
            <div class="t3">谛听咨询以“帮助客户解决管理问题，提高客户管理水平”为终极使命， 坚持“客户为先，共同成长”的核心价值观，遵守“诚信、开放，协作、共赢”的企业精神，为时间“客户最信誉的管理伙伴”的愿景，日夜兼程，风雨无阻。</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 2------------------------------ -->
    <div class="row2">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">名称由来</div>
      </div>

      <!-- row2内容 -->
      <div class="box2">
        小时候看《西游记》的时候有一集《真假美猴王》，悟空碰到了一个和自己一模一样的的猴子，在他们找了地府让阎王辨认，辨认不出来但是“谛听”却看明了什么虽未点破但由此可见他的能力。在佛教文化中“谛听”能起到“辟邪”、“消灾”、“护身”等作用;<br /><br />

        传说是地藏菩萨的坐骑，谛听的原身是一条白犬，因为地藏法门以孝道为基，狗性忠诚，就如同文殊之狮子表智慧，普贤之白象表大行一样，地藏之谛听表忠诚不二之心。《诗经·隰桑》云:“中心藏之何日忘之。”以此来表示心地之法要。请听的来历据认为，唐·开元末年，古新罗(今韩国)干子24岁的金乔觉，看破红尘，携白犬一只浮海来华，削发为僧。白犬伴金乔觉一路颠觞，卓锡九华,在共同苦
        修的75载中,白犬与金乔觉昼夜相随，处处使其逢凶化吉。<br /><br />
        元十年(794)农历七月三十日金乔觉坐化、白犬亦随之傍息。三年后，金乔觉尸身开缸，见其面目如生、骨如金锁。根据佛经曰:“菩萨钩锁、百骸鸣矣!”。众人都为金乔觉而感叹--金乔觉乃是地藏善
        萨化身，故建寺连白犬同请供奉。金乔觉被佛门认定为地藏菩萨之应化，称金地藏。这只神犬也因是金乔觉的信物、爱物、宠物和护身之物，被佛教尊称为神犬。后人更神化为神犬谛听晓佛理，通人 性，避邪恶,视为吉祥的象征。<br /><br />
        说善听具有“坐地听八百，卧耳听三千”的能力，又称“地听”“地”蕴涵心地的意思。如地藏偈赞云:“稽首本然净心地，无尽佛藏大慈尊” <br /><br />***所以，能用心听者为“善听”地听能辨别世间万物的声音，尤其善听人心，能顾鉴善恶，察听贤愚。***<br /><br />
        “地听”谐音“谛听”在佛理中，直俗二谛表示世间，出世间的佛法义理，所以“谛听”有用心聆听实佛理的意思，佛经中常有“谛听，谛听，善思念之”的辞句。<br /><br />
        后来谛听成了九华山的镇山之宝，被视为吉祥的象征，而其形象也大为改观，集众瑞象而成为具虎头、独角、犬耳、龙身、狮尾、麒麟足的瑞兽。简言之，独角表公断力，如《论语》中孔子认为子路说一不二，“片言可以折狱”。龙身表吉祥，虎头表示智勇，犬耳表善听，狮尾表有耐性,麒麟足表四平八稳，以善为宝。
      </div>
    </div>
    <!-- 3--------------------------- -->

    <div class="row3">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">核心能力</div>
      </div>

      <!-- 内容 -->
      <div class="box2">
        <div class="item2">
          <div class="b1">
            <div class="t1">诚信天下，合作共赢</div>
            <div class="line"></div>
            <div class="t2">我们精诚合作，在各自的擅长的领域为彼此服务。</div>
          </div>

          <div class="b2">
            <img src="@/image/products/ruanjian/tu2@2x.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AaacooxxIndex',

  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}

// 顶部
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/more/banner@2x.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

.row1 {
  height: 800px;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;

  .title {
    margin-top: 40px;
    display: flex;
    color: #000;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }

    .line {
      position: absolute;
      top: 110px;
      height: 4px;
      width: 60px;
      background-color: #4581fb;
    }
    .t2 {
      // padding-right: 100px;
      position: absolute;
      letter-spacing: 1px;
      top: 155px;
      color: #333333;
      font-size: 18px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box1 {
    margin-top: 200px;
    .item2 {
      display: flex;
      // justify-content: space-around;
      flex-wrap: wrap;
      width: 1400px;
      height: 400px;
      margin: 0 auto 0 auto;
      box-sizing: border-box;

      .b1 {
        width: 50%;
        background-color: #f7f8fb;

        position: relative;

        .t1 {
          font-size: 24px;
          position: absolute;
          top: 60px;
          left: 70px;

          color: #333333;
        }

        .line {
          position: absolute;
          left: 70px;
          top: 120px;
          height: 2px;
          width: 50px;
          background-color: #4581fb;
        }

        .t2 {
          padding-right: 50px;
          position: absolute;
          letter-spacing: 1px;
          line-height: 30px;
          font-size: 16px;
          left: 70px;
          top: 120px;
          color: #666666;
        }

        .t3 {
          padding-right: 50px;
          position: absolute;
          letter-spacing: 1px;
          line-height: 30px;
          font-size: 16px;
          left: 70px;
          top: 220px;
          color: #666666;
        }
      }

      .b2 {
        width: 50%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    position: absolute;
    bottom: 100px;
    width: 170px;
    left: 850px;
    height: 55px;
    line-height: 55px;
    text-align: center;
    border: 1px solid #ffffff;
    color: #fff;
    border-radius: 2px;
  }
}

.row3 {
  height: 750px;
  overflow: hidden;
  position: relative;
  background-image: url(@/image/more/beijing@2x.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: 30px;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 115px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box2 {
    margin-top: 90px;
    .item2 {
      display: flex;
      // justify-content: space-around;
      flex-wrap: wrap;
      width: 1400px;
      height: 420px;
      margin: 0 auto 0 auto;
      box-sizing: border-box;

      .b1 {
        width: 50%;
        background-color: rgba($color: #000000, $alpha: 0.5);

        position: relative;

        .t1 {
          font-size: 50px;
          position: absolute;
          top: 140px;
          left: 70px;
          letter-spacing: 1px;

          color: #ffffff;
        }

        .line {
          position: absolute;
          left: 70px;
          top: 90px;
          height: 5px;
          width: 60px;
          background-color: #ffffff;
        }

        .t2 {
          position: absolute;
          letter-spacing: 1px;
          line-height: 30px;
          font-size: 20px;
          left: 70px;
          top: 240px;
          color: #ffffff;
          letter-spacing: 2px;
        }
      }

      .b2 {
        width: 50%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.row2 {
  height: 780px;
  overflow: hidden;

  background-color: #ffffff;
  position: relative;

  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 90px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;
    width: 1400px;
    margin: 40px auto;
    color: #333333;
    line-height: 30px;
  }

  .zixun {
    letter-spacing: 1px;
    // position: absolute;
    bottom: 100px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 4px;
    margin: 260px auto;
  }
}
</style>
